"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageState = /** @class */ (function () {
    function MessageState() {
        this.show = true;
    }
    return MessageState;
}());
exports.default = MessageState;
//# sourceMappingURL=MessageState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Message/MessageState.js
// module id = 1204
// module chunks = 8